import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-create-subsidiary',
    templateUrl: './create-subsidiary.component.html',
    styleUrls: ['./create-subsidiary.component.css']
})

export class CreateSubsidiaryComponent implements OnInit {

    subsidiaryForm: FormGroup;
    subsidiary: any;

    @Input() initialValue: string;
    @Output() modelChange = new EventEmitter();

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private service: SubsidiaryService) {
        console.log('Subsidiary');

        this.initialValue = '';
    }

    ngOnInit() {
        this.subsidiaryForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            company: ['', Validators.required]
        });
    }

    onSubmit() {
        this.subsidiary = this.saveSubsidiary();

        this.service.postSubsidiary(this.subsidiary);
        this.subsidiaryForm.reset();
        this.router.navigate(['/sub']);
    }

    saveSubsidiary() {
        const currentDate = new Date();

        const saveSubsidiary = {
            active: 1,
            companyId: this.subsidiaryForm.get('company').value,
            createdAt: currentDate,
            description: this.subsidiaryForm.get('description').value,
            name: this.subsidiaryForm.get('name').value,
            updatedAt: currentDate
        };

        return saveSubsidiary;
    }

    change(newValue) {
        this.modelChange.emit(newValue);
    }

}
